import { combineReducers } from 'redux';

import global from './global';
import product from './product';
import category from './category';
import authenticate from './authenticate';
import transaction from './transaction';
import order from './order';
import ticket from './ticket';
import business from './business';
import customer from './customer';
import application from './application';
import tag from './tag';
import brand from './brand';

export default combineReducers({
  application,
  product,
  category,
  authenticate,
  global,
  transaction,
  order,
  ticket,
  business,
  customer,
  tag,
  brand,
});
